import React from 'react'

const WorkImage1 = () => {
  return (<>
    <svg
        className='h-[500px]'
          width="866"
          height="713"
          viewBox="0 0 866 713"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.6">
            <rect
              width="5.59836"
              height="5.59836"
              transform="matrix(0.707096 0.707118 -0.707096 0.707118 291.827 423.167)"
              fill="#2C2ABB"
            />
            <rect
              x="393.491"
              y="442.126"
              width="3.53503"
              height="3.53503"
              transform="rotate(45 393.491 442.126)"
              fill="#2C2ABB"
            />
            <rect
              x="227.665"
              y="390.93"
              width="4.64048"
              height="4.64048"
              transform="rotate(45 227.665 390.93)"
              fill="#2C2ABB"
            />
            <rect
              x="352.029"
              y="397.491"
              width="6.33179"
              height="6.33179"
              transform="rotate(45 352.029 397.491)"
              fill="#2C2ABB"
            />
            <rect
              width="8.2502"
              height="8.2502"
              transform="matrix(0.707114 0.707099 -0.707114 0.707099 247.247 474.415)"
              fill="#2C2ABB"
            />
            <rect
              x="378.074"
              y="523.893"
              width="3.68371"
              height="3.68371"
              transform="rotate(45 378.074 523.893)"
              fill="#2C2ABB"
            />
            <rect
              x="350.887"
              y="459.828"
              width="4.71694"
              height="4.71694"
              transform="rotate(45 350.887 459.828)"
              fill="#2C2ABB"
            />
            <rect
              width="3.97882"
              height="3.97882"
              transform="matrix(0.707122 0.707091 -0.707122 0.707091 307.659 462.854)"
              fill="#2C2ABB"
            />
            <rect
              x="327.242"
              y="479.207"
              width="5.45388"
              height="5.45388"
              transform="rotate(45 327.242 479.207)"
              fill="#2C2ABB"
            />
            <rect
              x="287.139"
              y="495.663"
              width="5.7468"
              height="5.7468"
              transform="rotate(45 287.139 495.663)"
              fill="#2C2ABB"
            />
            <rect
              x="274.848"
              y="521.808"
              width="2.94797"
              height="2.94797"
              transform="rotate(45 274.848 521.808)"
              fill="#2C2ABB"
            />
          </g>
          <g opacity="0.6">
            <rect
              width="5.59836"
              height="5.59836"
              transform="matrix(0.707118 0.707096 -0.707118 0.707096 497.677 458.814)"
              fill="#2C2ABB"
            />
            <rect
              x="599.339"
              y="477.772"
              width="3.53503"
              height="3.53503"
              transform="rotate(45 599.339 477.772)"
              fill="#2C2ABB"
            />
            <rect
              x="433.514"
              y="426.576"
              width="4.64048"
              height="4.64048"
              transform="rotate(45 433.514 426.576)"
              fill="#2C2ABB"
            />
            <rect
              width="6.33179"
              height="6.33179"
              transform="matrix(0.707116 0.707097 -0.707116 0.707097 557.878 433.137)"
              fill="#2C2ABB"
            />
            <rect
              width="8.2502"
              height="8.2502"
              transform="matrix(0.707114 0.707099 -0.707114 0.707099 453.097 510.062)"
              fill="#2C2ABB"
            />
            <rect
              x="583.925"
              y="559.539"
              width="3.68371"
              height="3.68371"
              transform="rotate(45 583.925 559.539)"
              fill="#2C2ABB"
            />
            <rect
              x="556.737"
              y="495.476"
              width="4.71694"
              height="4.71694"
              transform="rotate(45 556.737 495.476)"
              fill="#2C2ABB"
            />
            <rect
              x="513.509"
              y="498.499"
              width="3.97882"
              height="3.97882"
              transform="rotate(45 513.509 498.499)"
              fill="#2C2ABB"
            />
            <rect
              width="5.45388"
              height="5.45388"
              transform="matrix(0.707096 0.707118 -0.707096 0.707118 533.092 514.854)"
              fill="#2C2ABB"
            />
            <rect
              x="492.99"
              y="531.31"
              width="5.7468"
              height="5.7468"
              transform="rotate(45 492.99 531.31)"
              fill="#2C2ABB"
            />
            <rect
              x="480.699"
              y="557.454"
              width="2.94797"
              height="2.94797"
              transform="rotate(45 480.699 557.454)"
              fill="#2C2ABB"
            />
          </g>
          <g opacity="0.6">
            <rect
              x="424.837"
              y="171.212"
              width="4.90306"
              height="4.90306"
              transform="rotate(45 424.837 171.212)"
              fill="#2C2ABB"
            />
            <rect
              x="513.873"
              y="187.816"
              width="3.09599"
              height="3.09599"
              transform="rotate(45 513.873 187.816)"
              fill="#2C2ABB"
            />
            <rect
              x="368.643"
              y="142.979"
              width="4.06415"
              height="4.06415"
              transform="rotate(45 368.643 142.979)"
              fill="#2C2ABB"
            />
            <rect
              x="477.562"
              y="148.727"
              width="5.5454"
              height="5.5454"
              transform="rotate(45 477.562 148.727)"
              fill="#2C2ABB"
            />
            <rect
              x="385.792"
              y="216.096"
              width="7.22555"
              height="7.22555"
              transform="rotate(45 385.792 216.096)"
              fill="#2C2ABB"
            />
            <rect
              width="3.2262"
              height="3.2262"
              transform="matrix(0.707088 0.707126 -0.707088 0.707126 500.372 259.428)"
              fill="#2C2ABB"
            />
            <rect
              x="476.562"
              y="203.322"
              width="4.13111"
              height="4.13111"
              transform="rotate(45 476.562 203.322)"
              fill="#2C2ABB"
            />
            <rect
              x="438.704"
              y="205.969"
              width="3.48466"
              height="3.48466"
              transform="rotate(45 438.704 205.969)"
              fill="#2C2ABB"
            />
            <rect
              x="455.853"
              y="220.292"
              width="4.77652"
              height="4.77652"
              transform="rotate(45 455.853 220.292)"
              fill="#2C2ABB"
            />
            <rect
              x="420.731"
              y="234.706"
              width="5.03306"
              height="5.03306"
              transform="rotate(45 420.731 234.706)"
              fill="#2C2ABB"
            />
            <rect
              width="2.57847"
              height="2.57847"
              transform="matrix(0.707083 0.70713 -0.707083 0.70713 409.966 257.604)"
              fill="#2C2ABB"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M394.482 262.417L237.567 349.954L432.376 475.133L628.43 349.954L470.554 261.881L432.234 282.395L394.482 262.417Z"
            fill="url(#paint0_linear_714_2939)"
            fill-opacity="0.8"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M640.881 463.775L433.25 347.125L432.996 346.983L432.743 347.125L222.759 465.096L223.74 465.733L432.996 348.17L639.904 464.413L640.881 463.775Z"
            fill="url(#paint1_linear_714_2939)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M372.633 250.854L0.589355 458.839L430.161 712.539L865.411 453.162L495.504 248.527L432.237 282.394L372.633 250.854ZM434.457 319.695L655.009 454.543L431.542 600.55L210.99 457.458L434.457 319.695Z"
            fill="url(#paint2_linear_714_2939)"
          />
          <path
            d="M238.573 373.857L432.999 264.626L627.424 373.857L432.999 498.153L238.573 373.857Z"
            stroke="url(#paint3_linear_714_2939)"
            stroke-width="1.03515"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M549.238 219.762L438.803 160.293L316.76 221.288L436.556 284.556L549.238 219.762ZM516.758 219.973L438.704 175.857L349.24 221.073L436.824 265.028L516.758 219.973Z"
            fill="url(#paint4_linear_714_2939)"
          />
          <path
            d="M318.947 222.073L436.554 284.554L432.372 475.129L239.839 350.78L318.947 222.073Z"
            fill="url(#paint5_linear_714_2939)"
            fill-opacity="0.6"
          />
          <path
            d="M318.947 222.073L436.554 284.554L432.372 475.129L239.839 350.78L318.947 222.073Z"
            fill="url(#paint6_linear_714_2939)"
            fill-opacity="0.4"
          />
          <path
            d="M394.415 262.39L316.756 221.281L237.648 349.987L394.415 262.39Z"
            fill="url(#paint7_linear_714_2939)"
            fill-opacity="0.8"
          />
          <path
            d="M394.415 262.39L316.756 221.281L237.648 349.987L394.415 262.39Z"
            fill="url(#paint8_linear_714_2939)"
            fill-opacity="0.4"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M473.677 263.257L549.224 219.756L628.425 349.968L432.37 475.14L432.377 474.645L626.977 349.732L473.677 263.257Z"
            fill="url(#paint9_linear_714_2939)"
            fill-opacity="0.8"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M549.204 219.765L549.24 219.744L549.24 219.745L549.204 219.765ZM473.852 263.103L436.56 284.551L432.384 475.128L628.442 349.957L628.438 349.951L473.852 263.103Z"
            fill="url(#paint10_linear_714_2939)"
            fill-opacity="0.8"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M549.204 219.765L549.24 219.744L549.24 219.745L549.204 219.765ZM473.852 263.103L436.56 284.551L432.384 475.128L628.442 349.957L628.438 349.951L473.852 263.103Z"
            fill="url(#paint11_linear_714_2939)"
            fill-opacity="0.7"
          />
          <g filter="url(#filter0_f_714_2939)">
            <ellipse
              cx="319.056"
              cy="330.996"
              rx="20.8145"
              ry="20.8145"
              transform="rotate(-30 319.056 330.996)"
              fill="url(#paint12_radial_714_2939)"
            />
          </g>
          <rect
            width="132.504"
            height="5.91581"
            rx="2.95791"
            transform="matrix(0.866025 -0.500001 0.499999 0.866026 314.445 330.243)"
            fill="url(#paint13_linear_714_2939)"
            fill-opacity="0.6"
          />
          <g filter="url(#filter1_f_714_2939)">
            <ellipse
              cx="319.056"
              cy="330.996"
              rx="20.8145"
              ry="20.8145"
              transform="rotate(-30 319.056 330.996)"
              fill="url(#paint14_radial_714_2939)"
            />
          </g>
          <g filter="url(#filter2_f_714_2939)">
            <ellipse
              rx="20.8145"
              ry="20.8145"
              transform="matrix(-0.866024 -0.500002 -0.499998 0.866026 519.232 317.933)"
              fill="url(#paint15_radial_714_2939)"
            />
          </g>
          <rect
            width="132.504"
            height="5.91581"
            rx="2.95791"
            transform="matrix(-0.866025 -0.500001 -0.499999 0.866026 523.842 317.179)"
            fill="url(#paint16_linear_714_2939)"
            fill-opacity="0.9"
          />
          <g filter="url(#filter3_f_714_2939)">
            <circle
              r="27.5373"
              transform="matrix(-0.866025 -0.5 -0.5 0.866025 519.231 317.932)"
              fill="url(#paint17_radial_714_2939)"
            />
          </g>
          <g filter="url(#filter4_f_714_2939)">
            <circle
              r="20.8145"
              transform="matrix(-0.838934 -0.544234 -0.544234 0.838934 501.82 386.492)"
              fill="url(#paint18_radial_714_2939)"
            />
          </g>
          <rect
            width="82.3058"
            height="8.09328"
            rx="4.04664"
            transform="matrix(-0.838933 -0.544235 -0.544233 0.838934 505.628 384.138)"
            fill="url(#paint19_linear_714_2939)"
            fill-opacity="0.9"
          />
          <g filter="url(#filter5_f_714_2939)">
            <circle
              r="27.5373"
              transform="matrix(-0.838934 -0.544234 -0.544234 0.838934 501.821 386.492)"
              fill="url(#paint20_radial_714_2939)"
            />
          </g>
          <g filter="url(#filter6_f_714_2939)">
            <ellipse
              rx="15.711"
              ry="15.711"
              transform="matrix(-0.838932 -0.544236 -0.544232 0.838935 503.602 407.407)"
              fill="url(#paint21_radial_714_2939)"
            />
          </g>
          <rect
            width="93.3811"
            height="6.10888"
            rx="3.05444"
            transform="matrix(-0.838934 -0.544233 -0.544235 0.838933 506.475 405.632)"
            fill="url(#paint22_linear_714_2939)"
            fill-opacity="0.6"
          />
          <g filter="url(#filter7_f_714_2939)">
            <ellipse
              rx="20.7854"
              ry="20.7854"
              transform="matrix(-0.838935 -0.544232 -0.544235 0.838933 503.601 407.408)"
              fill="url(#paint23_radial_714_2939)"
            />
          </g>
          <g opacity="0.6">
            <g filter="url(#filter8_f_714_2939)">
              <circle
                cx="332.971"
                cy="369.574"
                r="10.4972"
                transform="rotate(-32.8046 332.971 369.574)"
                fill="url(#paint24_radial_714_2939)"
              />
            </g>
            <rect
              x="330.629"
              y="369.308"
              width="66.8241"
              height="2.98346"
              rx="1.49173"
              transform="rotate(-32.8046 330.629 369.308)"
              fill="url(#paint25_linear_714_2939)"
              fill-opacity="0.6"
            />
          </g>
          <rect
            width="66.8241"
            height="2.98346"
            rx="1.49173"
            transform="matrix(-0.869976 -0.493093 -0.493093 0.869976 582.875 310.269)"
            fill="url(#paint26_linear_714_2939)"
          />
          <g filter="url(#filter9_f_714_2939)">
            <circle
              r="10.4972"
              transform="matrix(-0.869976 -0.493093 -0.493093 0.869976 580.552 310.667)"
              fill="url(#paint27_radial_714_2939)"
            />
          </g>
          <g filter="url(#filter10_f_714_2939)">
            <circle
              r="14.4943"
              transform="matrix(-0.869976 -0.493093 -0.493093 0.869976 580.554 310.667)"
              fill="url(#paint28_radial_714_2939)"
            />
          </g>
          <g opacity="0.3">
            <rect
              width="66.8241"
              height="2.98346"
              rx="1.49173"
              transform="matrix(-0.869977 -0.493093 -0.493094 0.869976 589.859 346.827)"
              fill="url(#paint29_linear_714_2939)"
            />
            <g filter="url(#filter11_f_714_2939)">
              <circle
                r="10.4972"
                transform="matrix(-0.869976 -0.493093 -0.493093 0.869976 587.535 347.225)"
                fill="url(#paint30_radial_714_2939)"
              />
            </g>
          </g>
          <rect
            x="387.685"
            y="350.207"
            width="114.234"
            height="11.8726"
            rx="5.9363"
            transform="rotate(-31.6208 387.685 350.207)"
            fill="url(#paint31_linear_714_2939)"
            fill-opacity="0.6"
          />
          <g filter="url(#filter12_f_714_2939)">
            <circle
              cx="395.994"
              cy="352.062"
              r="35.0999"
              transform="rotate(-31.6208 395.994 352.062)"
              fill="url(#paint32_radial_714_2939)"
            />
          </g>
          <g opacity="0.5">
            <rect
              width="67.8232"
              height="9.89409"
              rx="4.94705"
              transform="matrix(0.866026 -0.499999 0.500001 0.866025 386.414 414.039)"
              fill="url(#paint33_linear_714_2939)"
              fill-opacity="0.6"
            />
            <g filter="url(#filter13_f_714_2939)">
              <circle
                cx="393.289"
                cy="415.782"
                r="29.2507"
                transform="rotate(-30 393.289 415.782)"
                fill="url(#paint34_radial_714_2939)"
              />
            </g>
          </g>
          <path
            d="M357.606 150.653L438.274 109.428L518.943 150.653L438.274 197.564L357.606 150.653Z"
            stroke="url(#paint35_linear_714_2939)"
            stroke-width="1.03515"
          />
          <path
            d="M438.274 97.8111L514.746 139.588L438.274 187.127L362.33 139.588L438.274 97.8111Z"
            fill="url(#paint36_linear_714_2939)"
            fill-opacity="0.6"
          />
          <path
            d="M362.331 139.588L438.279 187.132L442.233 0.944824L362.331 139.588Z"
            fill="url(#paint37_linear_714_2939)"
          />
          <path
            d="M362.331 139.588L438.279 187.132L442.233 0.944824L362.331 139.588Z"
            fill="url(#paint38_linear_714_2939)"
            fill-opacity="0.4"
          />
          <path
            d="M514.746 139.593L438.279 187.132L442.232 0.944824L514.746 139.593Z"
            fill="url(#paint39_linear_714_2939)"
            fill-opacity="0.8"
          />
          <g filter="url(#filter14_f_714_2939)">
            <ellipse
              cx="409.737"
              cy="101.361"
              rx="10.4972"
              ry="10.4972"
              transform="rotate(-32.8046 409.737 101.361)"
              fill="url(#paint40_radial_714_2939)"
            />
          </g>
          <g filter="url(#filter15_f_714_2939)">
            <ellipse
              cx="409.737"
              cy="101.361"
              rx="10.4972"
              ry="10.4972"
              transform="rotate(-32.8046 409.737 101.361)"
              fill="url(#paint41_radial_714_2939)"
            />
          </g>
          <rect
            width="36.1571"
            height="2.98346"
            rx="1.49173"
            transform="matrix(0.840522 -0.541777 0.541773 0.840525 407.396 101.094)"
            fill="url(#paint42_linear_714_2939)"
            fill-opacity="0.6"
          />
          <g filter="url(#filter16_f_714_2939)">
            <circle
              r="14.8426"
              transform="matrix(-0.866025 -0.5 -0.5 0.866025 489.24 133.467)"
              fill="url(#paint43_radial_714_2939)"
            />
          </g>
          <rect
            width="60.9571"
            height="4.2185"
            rx="2.10925"
            transform="matrix(-0.866024 -0.500002 -0.499998 0.866027 492.528 132.932)"
            fill="url(#paint44_linear_714_2939)"
            fill-opacity="0.9"
          />
          <g filter="url(#filter17_f_714_2939)">
            <circle
              r="19.6365"
              transform="matrix(-0.866025 -0.5 -0.5 0.866025 489.239 133.468)"
              fill="url(#paint45_radial_714_2939)"
            />
          </g>
          <g opacity="0.4">
            <g filter="url(#filter18_f_714_2939)">
              <circle
                r="10.4067"
                transform="matrix(-0.866025 -0.5 -0.5 0.866025 473.724 139.033)"
                fill="url(#paint46_radial_714_2939)"
              />
            </g>
            <rect
              width="42.7394"
              height="2.95775"
              rx="1.47888"
              transform="matrix(-0.866026 -0.5 -0.5 0.866025 476.028 138.656)"
              fill="url(#paint47_linear_714_2939)"
              fill-opacity="0.9"
            />
            <g filter="url(#filter19_f_714_2939)">
              <circle
                r="13.7679"
                transform="matrix(-0.866025 -0.5 -0.5 0.866025 473.723 139.032)"
                fill="url(#paint48_radial_714_2939)"
              />
            </g>
          </g>
          <g opacity="0.4">
            <g filter="url(#filter20_f_714_2939)">
              <ellipse
                rx="6.58759"
                ry="6.58759"
                transform="matrix(0.866028 -0.499995 0.500005 0.866023 410.808 128.223)"
                fill="url(#paint49_radial_714_2939)"
              />
            </g>
            <rect
              width="27.0545"
              height="1.87229"
              rx="0.936147"
              transform="matrix(0.866024 -0.500002 0.499998 0.866027 409.348 127.983)"
              fill="url(#paint50_linear_714_2939)"
              fill-opacity="0.9"
            />
            <g filter="url(#filter21_f_714_2939)">
              <ellipse
                rx="8.71526"
                ry="8.71526"
                transform="matrix(0.866023 -0.500004 0.499996 0.866028 410.808 128.221)"
                fill="url(#paint51_radial_714_2939)"
              />
            </g>
          </g>
          <path
            d="M514.746 139.593L438.279 187.132L442.232 0.944824L514.746 139.593Z"
            fill="url(#paint52_linear_714_2939)"
            fill-opacity="0.4"
          />
          <defs>
            <filter
              id="filter0_f_714_2939"
              x="295.133"
              y="307.073"
              width="47.8467"
              height="47.8472"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter1_f_714_2939"
              x="295.133"
              y="307.073"
              width="47.8467"
              height="47.8472"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter2_f_714_2939"
              x="495.309"
              y="294.009"
              width="47.8467"
              height="47.8472"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter3_f_714_2939"
              x="488.584"
              y="287.285"
              width="61.2944"
              height="61.2944"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter4_f_714_2939"
              x="477.897"
              y="362.569"
              width="47.8447"
              height="47.8447"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter5_f_714_2939"
              x="471.175"
              y="355.846"
              width="61.2915"
              height="61.292"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter6_f_714_2939"
              x="484.783"
              y="388.589"
              width="37.6367"
              height="37.6365"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter7_f_714_2939"
              x="479.708"
              y="383.515"
              width="47.7866"
              height="47.7866"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter8_f_714_2939"
              x="319.367"
              y="355.971"
              width="27.208"
              height="27.2078"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter9_f_714_2939"
              x="566.948"
              y="297.063"
              width="27.209"
              height="27.209"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter10_f_714_2939"
              x="562.952"
              y="293.065"
              width="35.2046"
              height="35.2046"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter11_f_714_2939"
              x="573.931"
              y="333.621"
              width="27.209"
              height="27.209"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter12_f_714_2939"
              x="357.784"
              y="313.852"
              width="76.4209"
              height="76.4206"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter13_f_714_2939"
              x="360.928"
              y="383.421"
              width="64.7222"
              height="64.7222"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter14_f_714_2939"
              x="396.133"
              y="87.7572"
              width="27.208"
              height="27.2078"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter15_f_714_2939"
              x="396.133"
              y="87.7572"
              width="27.208"
              height="27.2078"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter16_f_714_2939"
              x="471.29"
              y="115.517"
              width="35.9014"
              height="35.9011"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter17_f_714_2939"
              x="466.494"
              y="110.722"
              width="45.4907"
              height="45.4906"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter18_f_714_2939"
              x="460.209"
              y="125.519"
              width="27.0278"
              height="27.0279"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter19_f_714_2939"
              x="456.848"
              y="122.156"
              width="33.7515"
              height="33.7515"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter20_f_714_2939"
              x="401.114"
              y="118.529"
              width="19.3882"
              height="19.3882"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <filter
              id="filter21_f_714_2939"
              x="398.985"
              y="116.399"
              width="23.6445"
              height="23.6444"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1.55273"
                result="effect1_foregroundBlur_714_2939"
              />
            </filter>
            <linearGradient
              id="paint0_linear_714_2939"
              x1="585.012"
              y1="318.416"
              x2="273.912"
              y2="386.087"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#E8F5FF" />
              <stop offset="1" stop-color="#1E126B" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_714_2939"
              x1="459.809"
              y1="416.407"
              x2="454.276"
              y2="516.629"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#193DB9" stop-opacity="0" />
              <stop offset="1" stop-color="#57E1FF" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_714_2939"
              x1="433"
              y1="220.797"
              x2="433"
              y2="707.263"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.5" stop-color="#1D1644" stop-opacity="0.5" />
              <stop offset="0.84375" stop-color="#FF6BA0" />
              <stop offset="1" stop-color="#FFA6C6" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_714_2939"
              x1="432.999"
              y1="497.887"
              x2="432.999"
              y2="271.693"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.666667" stop-color="#9A98FF" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_714_2939"
              x1="549.238"
              y1="222.424"
              x2="316.76"
              y2="222.424"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.265625" stop-color="#52F5FF" />
              <stop offset="0.677083" stop-color="#5171E0" />
              <stop offset="1" stop-color="#FF86EC" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_714_2939"
              x1="382.177"
              y1="250.696"
              x2="277.88"
              y2="376.633"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.338542" stop-color="#FF7CCB" />
              <stop offset="0.354167" stop-color="#FF7CCB" />
              <stop offset="1" stop-color="#12406B" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_714_2939"
              x1="389.354"
              y1="263.75"
              x2="307.031"
              y2="395.386"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.512495" stop-color="white" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_714_2939"
              x1="316.032"
              y1="229.413"
              x2="304.55"
              y2="338.663"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EDFF7C" />
              <stop offset="0.572917" stop-color="#FF7CCB" />
              <stop offset="1" stop-color="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_714_2939"
              x1="359.39"
              y1="242.765"
              x2="327.781"
              y2="322.942"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.512495" stop-color="white" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_714_2939"
              x1="486.554"
              y1="238.869"
              x2="590.348"
              y2="376.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.255208" stop-color="#132C85" />
              <stop offset="0.65625" stop-color="#FF87F3" />
              <stop offset="0.975883" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_714_2939"
              x1="442.448"
              y1="230.704"
              x2="615.263"
              y2="350.197"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.191757" stop-color="#0F246D" stop-opacity="0.6" />
              <stop offset="0.646372" stop-color="#88C6FF" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_714_2939"
              x1="443.431"
              y1="475.128"
              x2="499.268"
              y2="303.862"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF5EAB" />
              <stop offset="1" stop-color="#FF5EAB" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint12_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(319.056 330.996) rotate(90) scale(20.8145 20.8145)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint13_linear_714_2939"
              x1="1.64011"
              y1="5.91566"
              x2="140.703"
              y2="5.91566"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint14_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(319.056 330.996) rotate(90) scale(20.8145 20.8145)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint15_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(20.8145 20.8145) rotate(90) scale(20.8145 20.8145)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint16_linear_714_2939"
              x1="1.64011"
              y1="5.91566"
              x2="140.703"
              y2="5.91566"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#9EF9FF" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint17_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(27.5373 27.5373) rotate(90) scale(27.5373)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint18_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(20.8145 20.8145) rotate(90) scale(20.8145)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint19_linear_714_2939"
              x1="1.01877"
              y1="8.09307"
              x2="87.399"
              y2="8.09307"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#9EF9FF" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint20_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(27.5373 27.5373) rotate(90) scale(27.5373)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF7BCA" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint21_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(15.711 15.711) rotate(90) scale(15.711 15.711)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint22_linear_714_2939"
              x1="1.15586"
              y1="6.10873"
              x2="99.1596"
              y2="6.10873"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#9EF9FF" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint23_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(20.7854 20.7854) rotate(90) scale(20.7854 20.7854)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FFAFDF" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint24_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(332.971 369.574) rotate(90) scale(10.4972)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint25_linear_714_2939"
              x1="331.457"
              y1="372.291"
              x2="401.589"
              y2="372.291"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint26_linear_714_2939"
              x1="0.827139"
              y1="2.98338"
              x2="70.9593"
              y2="2.98338"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint27_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(10.4972 10.4972) rotate(90) scale(10.4972)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint28_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(14.4943 14.4943) rotate(90) scale(14.4943)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint29_linear_714_2939"
              x1="0.827139"
              y1="2.98338"
              x2="70.9593"
              y2="2.98338"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint30_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(10.4972 10.4972) rotate(90) scale(10.4972)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint31_linear_714_2939"
              x1="389.099"
              y1="362.079"
              x2="508.987"
              y2="362.079"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#D8FFFD" />
              <stop offset="0.875" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint32_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(395.994 352.062) rotate(90) scale(35.0999)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint33_linear_714_2939"
              x1="0.839505"
              y1="9.89384"
              x2="72.0201"
              y2="9.89384"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#D8FFFD" />
              <stop offset="1" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint34_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(393.289 415.782) rotate(90) scale(29.2507)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint35_linear_714_2939"
              x1="438.274"
              y1="197.828"
              x2="438.274"
              y2="111.761"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.666667" stop-color="#9A98FF" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint36_linear_714_2939"
              x1="453.298"
              y1="91.3815"
              x2="433.585"
              y2="165.657"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#132C85" />
              <stop offset="0.807292" stop-color="#FF87F3" />
              <stop offset="0.975883" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint37_linear_714_2939"
              x1="373.639"
              y1="-6.44215"
              x2="356.796"
              y2="164.261"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.161458" stop-color="#EDFF7C" />
              <stop offset="0.637806" stop-color="#FF7CCB" stop-opacity="0.8" />
              <stop offset="1" stop-color="#00F0FF" stop-opacity="0.7" />
            </linearGradient>
            <linearGradient
              id="paint38_linear_714_2939"
              x1="442.233"
              y1="4.27916"
              x2="404.254"
              y2="39.9815"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.338173" stop-color="white" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint39_linear_714_2939"
              x1="442.232"
              y1="0.944824"
              x2="434.068"
              y2="171.3"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.00313583" stop-color="#00E0FF" />
              <stop offset="0.545394" stop-color="#3E2DA5" stop-opacity="0.8" />
              <stop offset="1" stop-color="#FFF0F0" />
            </linearGradient>
            <radialGradient
              id="paint40_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(409.737 101.361) rotate(90) scale(10.4972 10.4972)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint41_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(409.737 101.361) rotate(90) scale(10.4972 10.4972)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint42_linear_714_2939"
              x1="0.447548"
              y1="2.98338"
              x2="38.3946"
              y2="2.98338"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.828125" stop-color="white" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint43_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(14.8426 14.8426) rotate(90) scale(14.8426)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint44_linear_714_2939"
              x1="0.754518"
              y1="4.2184"
              x2="64.7292"
              y2="4.2184"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#9EF9FF" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint45_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(19.6365 19.6365) rotate(90) scale(19.6365)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint46_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(10.4067 10.4067) rotate(90) scale(10.4067)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint47_linear_714_2939"
              x1="0.529022"
              y1="2.95768"
              x2="45.3842"
              y2="2.95768"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#9EF9FF" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint48_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(13.7679 13.7679) rotate(90) scale(13.7679)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint49_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(6.58759 6.58759) rotate(90) scale(6.58759 6.58759)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint50_linear_714_2939"
              x1="0.334877"
              y1="1.87225"
              x2="28.7287"
              y2="1.87225"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#9EF9FF" />
              <stop offset="0.828125" stop-color="#9CE7FF" stop-opacity="0" />
            </linearGradient>
            <radialGradient
              id="paint51_radial_714_2939"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(8.71526 8.71526) rotate(90) scale(8.71526)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#FF38B0" stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="paint52_linear_714_2939"
              x1="503.966"
              y1="144.991"
              x2="459.577"
              y2="95.8883"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="white" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
  </>
  )
}

export default WorkImage1